import React, { useState, useContext, useMemo, useEffect } from "react";
import {
  Form,
  Button,
  Row,
  Col,
  Card,
  Container,
} from "react-bootstrap";
import {
  FaTrash,
  FaBed,
  FaBath,
  FaRulerCombined,
  FaMapMarkerAlt,
} from "react-icons/fa";
import Select from "react-select";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { InfoContext } from "../providers/InfosContextProvider";
import { buildPublicAssetPath } from "../utils/publicAssetPath";
import PropertyImageCarousel from "../components/PropertyImageCarousel";
import { heroBackgroundStyle, preloadPropertyCover } from "../utils/images";
const customTheme = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary50: "#e0e0e0",
    primary: "#d3d3d3",
    primary25: "#f0f0f0",
    neutral0: "#ffffff",
    neutral20: "#d3d3d3",
    neutral30: "#bfbfbf",
    neutral40: "#d3d3d3",
    neutral50: "#6c757d",
    neutral60: "#808080",
    neutral80: "#000000",
  },
});

const Results = () => {
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedBedrooms, setSelectedBedrooms] = useState(null);
  const [selectedBathrooms, setSelectedBathrooms] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [firstTime, setFirstTime] = useState(true);

  const { options, houses, texts } = useContext(InfoContext);
  const navigate = useNavigate();

  useEffect(() => {
    const pageTitle =
      texts?.header?.buy || texts?.results?.sort || "Resultados";
    document.title = `${pageTitle} | Casas do Nabão`;
  }, [texts]);

  const location = useLocation();
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const transactionParam = queryParams.get("transaction") ?? "";
  const typeParam = queryParams.get("type") ?? "";
  const bedroomsParam = queryParams.get("bedrooms") ?? "";
  const bathroomsParam = queryParams.get("bathrooms") ?? "";
  const sortParam = queryParams.get("sort") ?? "";

  useEffect(() => {
    if (firstTime && options.transaction?.length !== 0) {
      if (transactionParam)
        setSelectedTransaction(
          options.transaction.find(
            (option) => option.value === transactionParam,
          ),
        );
      if (typeParam)
        setSelectedType(
          options.type.find((option) => option.value === typeParam),
        );
      if (bedroomsParam)
        setSelectedBedrooms(
          options.bedrooms.find((option) => option.value === bedroomsParam),
        );
      if (bathroomsParam)
        setSelectedBathrooms(
          options.bathrooms.find((option) => option.value === bathroomsParam),
        );
      if (sortParam)
        setSelectedFilter(
          options.sort.find((option) => option.value === sortParam),
        );

      setFirstTime(false);

      //window.history.replaceState({}, document.title, location.pathname);
    }
  }, [
    firstTime,
    options,
    transactionParam,
    typeParam,
    bedroomsParam,
    bathroomsParam,
    sortParam,
    location.pathname,
  ]);

  const clearAllSelections = () => {
    setSelectedFilter(null);
    setSelectedTransaction(null);
    setSelectedType(null);
    setSelectedBedrooms(null);
    setSelectedBathrooms(null);
  };

  const handleCardClick = (id) => {
    navigate(`/property/${id}`);
  };

  const sortProperties = (properties, filter) => {
    switch (filter) {
      case "newest":
        return properties.sort((a, b) => b.id - a.id);
      case "oldest":
        return properties.sort((a, b) => a.id - b.id);
      case "priceAsc":
        return properties.sort(
          (a, b) =>
            parseFloat(a.price.replace("€", "").replace(",", "")) -
            parseFloat(b.price.replace("€", "").replace(",", "")),
        );
      case "priceDesc":
        return properties.sort(
          (a, b) =>
            parseFloat(b.price.replace("€", "").replace(",", "")) -
            parseFloat(a.price.replace("€", "").replace(",", "")),
        );
      default:
        return properties;
    }
  };

  const filterProperties = (properties) => {
    let filteredProperties = properties;

    if (selectedTransaction) {
      filteredProperties = filteredProperties.filter(
        (property) => property.transaction === selectedTransaction.value,
      );
    }
    if (selectedType) {
      filteredProperties = filteredProperties.filter(
        (property) => property.typeProperty === selectedType.value,
      );
    }
    if (selectedBedrooms) {
      filteredProperties = filteredProperties.filter(
        (property) => property.bedrooms === Number(selectedBedrooms.value),
      );
    }
    if (selectedBathrooms) {
      filteredProperties = filteredProperties.filter(
        (property) => property.bathrooms === Number(selectedBathrooms.value),
      );
    }

    return filteredProperties;
  };

  const filteredProperties = filterProperties(houses);

  return (
    <>
      <Header />
      <div
        className="hero-background search-container"
        style={heroBackgroundStyle}
      >
        <div className="search-content">
          <Form>
            <Row className="align-items-end">
              <Col className="inputs" md={6} lg={3}>
                <Form.Group controlId="type-transaction">
                  <Select
                    options={options.transaction}
                    value={selectedTransaction}
                    onChange={setSelectedTransaction}
                    theme={customTheme}
                    placeholder={`${texts.search.transaction}`}
                    isSearchable={false}
                  />
                </Form.Group>
              </Col>

              <Col className="inputs" md={6} lg={3}>
                <Form.Group controlId="type-property">
                  <Select
                    options={options.type}
                    value={selectedType}
                    onChange={setSelectedType}
                    theme={customTheme}
                    placeholder={`${texts.search.type}`}
                    isSearchable={false}
                  />
                </Form.Group>
              </Col>

              <Col className="inputs" md={6} lg={3}>
                <Form.Group controlId="bedrooms">
                  <Select
                    options={options.bedrooms}
                    value={selectedBedrooms}
                    onChange={setSelectedBedrooms}
                    theme={customTheme}
                    placeholder={`${texts.search.bedrooms}`}
                    isSearchable={false}
                  />
                </Form.Group>
              </Col>

              <Col className="inputs" md={6} lg={3}>
                <Form.Group controlId="bathrooms">
                  <Select
                    options={options.bathrooms}
                    value={selectedBathrooms}
                    onChange={setSelectedBathrooms}
                    theme={customTheme}
                    placeholder={`${texts.search.bathrooms}`}
                    isSearchable={false}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Col md={12} lg={12} className="text-right">
              <div className="search-icon">
                <Button className="btn-clear" onClick={clearAllSelections}>
                  <FaTrash /> {`${texts.search.clear}`}
                </Button>
              </div>
            </Col>
          </Form>
        </div>
      </div>

      <Container className="p-3">
        <div className="results">
          <Row className="results-container">
            <Col xs={6} md={6} className="text-start mb-2 mb-md-0">
              <span className="bold">{filteredProperties.length}</span>
              {`${texts.results.result}`}
            </Col>
            <Col xs={0} md={4} className="d-none d-md-block"></Col>
            <Col xs={6} md={2} className="text-end sort">
              <Form.Group controlId="sort">
                <Select
                  options={options.sort}
                  value={selectedFilter}
                  onChange={setSelectedFilter}
                  theme={customTheme}
                  placeholder={`${texts.results.sort}`}
                  isSearchable={false}
                />
              </Form.Group>
            </Col>
          </Row>
        </div>
        <Row>
          {sortProperties(
            filteredProperties,
            selectedFilter ? selectedFilter.value : null,
          ).map((property) => (
            <Col key={property.id} xs={12} md={6} lg={4} className="mb-4">
              <Card
                className="property-card"
                onMouseEnter={() => preloadPropertyCover(property)}
                onTouchStart={() => preloadPropertyCover(property)}
              >
                <PropertyImageCarousel
                  property={property}
                  interval={null}
                  indicators={false}
                  onImageClick={() => handleCardClick(property.id)}
                  overlay={<div className="property-price">{property.price}</div>}
                >
                  <div className="properties-container">
                    {property.efficiency.length === 1 ? (
                      <div className="property-efficiency">
                        <img
                          src={buildPublicAssetPath(
                            `/assets/images/efficiency/${property.efficiency[0]}_RGB.png`,
                          )}
                          alt={`Eficiência Energética ${property.efficiency[0]}`}
                        />
                      </div>
                    ) : (
                      property.efficiency.map((efficiency, index) => (
                        <Col key={index} xs={6} className="property-efficiency">
                          <img
                            src={buildPublicAssetPath(
                              `/assets/images/efficiency/${efficiency}_RGB.png`,
                            )}
                            alt={`Eficiência Energética ${efficiency}`}
                          />
                        </Col>
                      ))
                    )}
                  </div>
                </PropertyImageCarousel>

                <div className="property-info">
                  <Row>
                    <Col xs={12}>
                      <span>
                        <FaMapMarkerAlt /> {property.location}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4}>
                      <span>
                        <FaBed /> {property.bedrooms || "-"}
                      </span>
                    </Col>
                    <Col xs={4}>
                      <span>
                        <FaRulerCombined /> {property.area || "-"}
                      </span>
                    </Col>
                    <Col xs={4}>
                      <span>
                        <FaBath /> {property.bathrooms || "-"}
                      </span>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default Results;
